<template>
    <div class="wrap-item-electronic-lecture b-item-lecture">
        <router-link class="link-click" :title="item.name"
            :to="{ path: getPath, query: { id: item.id, nameClass: nameClass, namePageDetail: item.name, classSchoolId: item.classSchoolId, listGroupId: item.listGroupId } }"
            target="_blank">
        </router-link>
        <div class="header-item-electronic-lecture">
            <div class="display-flex justify-content-between b-ellipsis" :title="item.name">
                <h5 class="font-weight-bold">
                    {{ item.name }}
                </h5>
            </div>

        </div>
        <div class="body-item-electronic-lecture">
            <div class="list-assigned b-ellipsis">
                Danh sách được giao: {{ item.listClassGroupName }}
            </div>
            <div class="complete-rate">
                Tỉ lệ hoàn thành: {{ formatNumber(((item.countCompleted || 0) / (item.countMember || 1) * 100)) }}%
            </div>
            <div class="status">
                Trạng thái: {{ item.statusName }}
            </div>
            <div class="complete-duration">
                Thời hạn hoàn thành: {{ moment(item.duration).format(formatDate) }}
                <img @click="handleEditDuration" class="icon-edit" src="@/assets/img/edit.png" />
            </div>
        </div>

        <div class="footer-item-electronic-lecture">
            <div class="display-flex-center cg-1">
                <a @click="handelRecovery" class="text-danger btn-recovery" href="#">Thu hồi</a>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
export default {
    name: "ItemElectronicLecture",
    components: {

    },
    props: {
        item: {
            type: Object,
            default: {}
        },
        nameClass: {
            type: String,
            default: ''
        },
        type: {
            type: Number,
            default: 1
        },
    },
    watch: {

    },
    data() {
        return {
            formatDate: "DD/MM/YYYY-HH:hh",
            statusEnum: {
                '1': 'Đang giao',
                '2': 'Đang hoàn thành',
                '3': 'Đã hoàn thành'
            }
        }
    },
    computed: {
        getPath() {
            if (this.type == 2) {
                return '/chi-tiet-ke-hoach-bai-day-da-giao'
            }
            return '/chi-tiet-bai-giang-dien-tu-da-giao'
        }
    },
    mounted() {

    },
    methods: {
        moment,
        textStatus(value) {
            return this.statusEnum[`${value}`]
        },
        formatNumber(value) {
            if (typeof value !== 'number') {
                return value;
            }
            return value.toFixed(0);
        },
        handelRecovery() {
            this.$emit('handelRecovery', this.item)
        },
        handleEditDuration() {
            this.$emit('handleEditDuration', this.item)
        }
    }
}
</script>
<style lang="scss" scoped>
.min-width-30r {
    min-width: 30rem !important;
}

.link-item {
    color: black;
}

.margin-left-10 {
    margin-left: 10px;
}

.wrap-item-electronic-lecture {
    color: black;
    margin-top: 10px;
    border-radius: 20px;
    min-height: 10rem;
    padding: 0px;
    border: 1px solid #80bdff;
    display: flex;
    flex-direction: column;
    justify-content: left;
}

.header-item-electronic-lecture {
    padding: 0.8rem 1rem;
    padding-bottom: 0.25rem;
    border-radius: 20px 20px 0px 0px;
}

.body-item-electronic-lecture {
    padding: 0.5rem 1rem;
    padding-top: 0;
}

.footer-item-electronic-lecture {
    padding: 0 1rem;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
}

.btn-assign {
    border-radius: 20px;
    background-color: #0f3dba;
    padding-left: 2rem;
    padding-right: 2rem;
}

.b-item-lecture {
    position: relative;
}

.link-click {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 0;
}

.icon-edit {
    width: 15px;
    cursor: pointer;
    z-index: 1;
    position: relative;
}

.btn-recovery {
    z-index: 1;
    position: relative;
}
</style>